import * as  prohibitedActions from './../actions/prohibitedItems.js';
import _ from "lodash";
import { convertDateFromUTC } from './../services/dst';
import { KeyCookieDisplayNewUpdateProhibited, KeyCookieLastUpdateItemProhibited, KeyCookieDisplayContentWarningProhibited, TimeExpiresCookieProhibited, KeyCookieLastUpdateItemProhibitedLocal } from './../constants';
import { getKeyCookieOfUserCurrent } from './../services/prohibitedHelper';
import Cookies from 'js-cookie';
const initState = {
    displayNewUpdateProhibited: 0,
    displayContentWarningProhibited: 0,
    lastUpdateProhibited: null,
    lastestUpdateDTOrigin: null
};
const time_expries_cookies = { expires: TimeExpiresCookieProhibited }


export default (state = initState, action) => {
    //get key cookie of user current
    const keyCookieDisplay = getKeyCookieOfUserCurrent(KeyCookieDisplayNewUpdateProhibited);
    const keylastUpdate = getKeyCookieOfUserCurrent(KeyCookieLastUpdateItemProhibited)
    const keyCookieDisplayWarning = getKeyCookieOfUserCurrent(KeyCookieDisplayContentWarningProhibited);
    switch (action.type) {
        case prohibitedActions.GET_LIST_PROHIBITED_ITEMS_SUCCESS:
            return {
                ...state,
                items: action.payload,
            }
        case prohibitedActions.GET_LIST_PROHIBITED_ITEMS_FAILS: 
            return {
                ...state,
                items: [],
            }
        // action CHECK_COOKIES_LAST_UPDATE_ITEM_PROHIBITED
        case prohibitedActions.CHECK_COOKIES_LAST_UPDATE_ITEM_PROHIBITED: 
            let LastestUpdateDT = convertDateFromUTC(action.payload.LastestUpdateDT);
            let lastestUpdateDTOrigin = action.payload.LastestUpdateDT;
            let displayNewUpdateProhibited = action.payload.HasShowNotice
            return {
                ...state,
                displayNewUpdateProhibited,
                lastestUpdateDTOrigin,
                lastUpdateProhibited: LastestUpdateDT
            }
        // action ON_CHANGE_DISPLAY_NEW_UPDATE_PROHIBITED
        case prohibitedActions.ON_CHANGE_DISPLAY_NEW_UPDATE_PROHIBITED: {
            return {
                ...state,
                displayNewUpdateProhibited: action.payload.statusDisplay,
            }
        }
        // action CHECK_COOKIES_DISPLAY_CONTENT_WARNING
        case prohibitedActions.CHECK_COOKIES_DISPLAY_CONTENT_WARNING: 
            let displayContentWarningProhibited = Cookies.get(keyCookieDisplayWarning);
            if (displayContentWarningProhibited === undefined) {
                displayContentWarningProhibited = 1;
                Cookies.set(keyCookieDisplayWarning, 1, time_expries_cookies);
            } 
            return {
                ...state,
                displayContentWarningProhibited
            }
        // action ON_CHANGE_DISPLAY_CONTENT_WARNING
        case prohibitedActions.ON_CHANGE_DISPLAY_CONTENT_WARNING: 
            if (action.payload) {
                Cookies.set(keyCookieDisplayWarning, 1, time_expries_cookies);
            } else {
                Cookies.set(keyCookieDisplayWarning, 0, time_expries_cookies);
            }
            return {
                ...state,
                displayContentWarningProhibited: action.payload
            }
        default:
            return state
    }
}




// WEBPACK FOOTER //
// ./src/reducers/prohibitedItems.js